import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyPageShellBg, type PageShellBgState } from "./pageShellBg";

/**
 * 页面级：挂载 + Tab/状态变化时刷 body 背景与标题。
 * pathname 入 deps，保证 SPA 内每次路由变化都会重新写入 body.style.backgroundColor。
 */
export function usePageShellBg(state: PageShellBgState): void {
  const { bg, front, title } = state;
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    applyPageShellBg({ bg, front, title });
  }, [bg, front, title, pathname]);
}
